'use strict';

const {isAplusWechatAmountEligible, paymentMethodFamilies} = require('../controllers/utilities/aplus-wechat-availability');

// The owner API must return a dedicated offer. A CNY Antpay offer is never a
// substitute for the independent APlus WeChat policy or checkout identity.
function aplusWechatOfferEnabled(offer, at = Date.now()) {
  return !!offer && offer.paymentMethod === 'aplus_wechat' && offer.currency === 'CNY' &&
    typeof offer.amountMinor === 'string' && /^[1-9][0-9]{0,14}$/.test(offer.amountMinor) &&
    Number.isSafeInteger(offer.expiresAt) && offer.expiresAt > at &&
    offer.enabled !== false && offer.available !== false &&
    isAplusWechatAmountEligible(Number(offer.amountMinor), undefined, at);
}

function visibleCardOffers(offers, at = Date.now()) {
  return (Array.isArray(offers) ? offers : []).filter(offer =>
    offer.paymentMethod !== 'aplus_wechat' || aplusWechatOfferEnabled(offer, at));
}

module.exports = {aplusWechatOfferEnabled, visibleCardOffers, paymentMethodFamilies};
